export default __webpack_public_path__ + "static/media/quantity-interview.16a2e8f2.svg";